/* global localStorage:false, swal:false */
(function () {
  "use strict";

  angular
    .module("admin.communities.posts.service", [])
    .factory("CommunitiesPostsService", CommunitiesPostsService);

  /** @ngInject */
  function CommunitiesPostsService($http, $q, API) {
    function listPostsUnpublished(userId, start, limit) {
      var defer = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/users/" +
            userId +
            "/community_posts/unpublished?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defer.resolve);

      return defer.promise;
    }

    function listPostsPublished(userId, start, limit) {
      var defer = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/users/" +
            userId +
            "/community_posts/published?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defer.resolve);

      return defer.promise;
    }

    return {
      listPostsPublished: listPostsPublished,
      listPostsUnpublished: listPostsUnpublished,
    };
  }
})();
